module.exports = __webpack_public_path__ + "img/5-2.7276c703.png";